import React, { useContext } from "react";
import { Redirect } from "react-router-dom";
import Spinner from "../../components/Spinner";
import { KeycloakContext } from "./KeycloakContext";

export default function AuthCallbackPage() {
  const { initialized, authenticated } = useContext(KeycloakContext);

  if (!initialized) return <Spinner isFullScreen />;
  return authenticated ? (
    <Redirect to="/dashboard" />
  ) : (
    <Redirect to="/auth/login" />
  );
}
